import React from 'react';
import { SvgIcon } from '@mui/material';

export default function AddToCart({ fill = '#cacdd9', ...props }) {
  return (
    <SvgIcon width="25.452" height="24" viewBox="0 0 25.452 23" {...props}>
      <g transform="translate(0)">
        <path
          d="M13.92,21A1.778,1.778,0,1,0,15.6,22.778,1.732,1.732,0,0,0,13.92,21Z"
          transform="translate(-0.89 -1.553)"
          fill={fill}
        />
        <path
          d="M22.27,21a1.778,1.778,0,1,0,1.676,1.778A1.741,1.741,0,0,0,22.27,21Z"
          transform="translate(-1.508 -1.553)"
          fill={fill}
        />
        <path
          d="M24.948,12.344h0a.787.787,0,0,0-.676,0,.926.926,0,0,0-.444.519l-.833,2.426H10.52L5.556.62A.926.926,0,0,0,4.714,0H.843A.926.926,0,0,0,0,.926v2.2a.926.926,0,0,0,.87.926.926.926,0,0,0,.843-.926V1.852H4.121l5.01,14.706a.861.861,0,0,0,.8.62H23.568a.87.87,0,0,0,.778-.6l1.046-3.037A.982.982,0,0,0,24.948,12.344Z"
          transform="translate(0)"
          fill={fill}
        />
      </g>
    </SvgIcon>
  );
}
